import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigation } from '../../contexts/NavigationContext';
import { homeLogoPath } from '../../utils/hubNavigation';
import logo from '../../../assets/images/logo.jpeg';
import HeaderSearch from '../SearchBars/HeaderSearch/HeaderSearch';

const Header = (props) => {
	const { user, authenticated, fitnessHubsOnly } = useAuth();
	const { openAccordion, isAccordionOpen } = useNavigation();

	const logoPath = homeLogoPath({ authenticated, user, fitnessHubsOnly });

	return (
		<nav className="relative z-30 flex items-center bg-ff-black shadow-xl">
			<div className="mx-auto">
				<Link to={logoPath}>
					<img src={logo} className="h-24" alt="Logo" />
				</Link>
			</div>
			<div className="absolute top-3 right-4">
				<HeaderSearch searchEndpoint={props.search_endpoint} />
			</div>
			{!isAccordionOpen && (
				<div className="absolute inset-y-0 left-7 z-10 flex items-center">
					<button
						type="button"
						onClick={openAccordion}
						className="flex items-center justify-center p-3 rounded-lg text-white hover:bg-white hover:bg-opacity-10 transition-colors"
						aria-label="Open navigation menu"
					>
						<i className="fa-solid fa-bars text-2xl leading-none" />
					</button>
				</div>
			)}
		</nav>
	);
};

export default Header;
